import { useEffect, useState } from "react";
import { api, gbp } from "@/lib/api";
import { PageHero } from "@/components/PageHero";
import { BookingDialog } from "@/components/BookingDialog";
import { Button } from "@/components/ui/button";
import { Loader2, Users, Settings2, MapPin } from "lucide-react";

export default function CarHire() {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/carhire").then(({ data }) => setCars(data)).finally(() => setLoading(false)); }, []);

  return (
    <div>
      <PageHero title="Car hire" subtitle="Drive your way — great rates on cars at airports worldwide." image="https://images.unsplash.com/photo-1503376780353-7e6692767b70" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        {loading ? <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-[#0B3C5D]" /></div> : (
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
            {cars.map((c) => (
              <div key={c.id} data-testid={`car-card-${c.id}`} className="bg-white rounded-2xl border border-slate-200 overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                <div className="h-40"><img src={c.image} alt={c.name} className="w-full h-full object-cover" /></div>
                <div className="p-5">
                  <span className="text-[10px] font-bold uppercase tracking-widest text-[#FF6B35]">{c.car_type}</span>
                  <h3 className="font-display font-semibold text-slate-900">{c.name}</h3>
                  <div className="flex gap-3 text-xs text-slate-500 mt-2">
                    <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {c.seats}</span>
                    <span className="flex items-center gap-1"><Settings2 className="w-3.5 h-3.5" /> {c.transmission}</span>
                  </div>
                  <p className="text-xs text-slate-400 flex items-center gap-1 mt-1"><MapPin className="w-3 h-3" /> {c.location}</p>
                  <div className="flex items-end justify-between mt-4 pt-4 border-t border-slate-100">
                    <div><p className="text-[11px] text-slate-400">per day</p><p className="font-display text-xl font-bold text-[#0B3C5D]">{gbp(c.price_per_day)}</p></div>
                    <BookingDialog productType="carhire" item={c} unitPrice={c.price_per_day}
                      trigger={<Button data-testid={`book-car-${c.id}`} className="rounded-full bg-[#FF6B35] hover:bg-[#e85a26] text-white font-semibold">Hire</Button>} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
